import { createAsyncThunk } from '@reduxjs/toolkit'
import { _fetchStoreInfo } from 'src/utils/api'

export const fetchStoreInfo = createAsyncThunk('store/fetch_store', async (param: string) => {
    const response = await _fetchStoreInfo(param)
    return { data: response.data}
})
